<template>
  <div data-testid="cycle-header" class="d-flex align-center gap-3">
    <v-btn
      v-if="showBack"
      @click="$emit('back')"
      class="pa-1 border-on"
      small
      data-testid="cycle-header__back-btn"
    >
      <v-icon>mdi-arrow-left</v-icon>
    </v-btn>
    <h3 class="font-weight-medium" data-testid="cycle-header__title">
      {{ cycletype === 'Actual' ? actualLabel : forecastLabel }}
    </h3>
    <v-tooltip bottom content-class="tooltip-bottom">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-bind="attrs"
          v-on="on"
          icon
          class="shadow-off"
          @click="emitRefreshData"
          data-testid="cycle-header__refresh-btn"
        >
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
      </template>
      <span data-testid="cycle-header__refresh-label">{{ refreshLabel }}</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  name: 'CycleHeader',
  props: {
    cycletype: {
      type: String,
      required: true
    },
    forecastLabel: {
      type: String,
      default: 'Forecast Cycle'
    },
    actualLabel: {
      type: String,
      default: 'Actual Cycle'
    },
    refreshLabel: {
      type: String,
      default: 'Refresh'
    },
    showBack: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    /**
     * Emits the refresh-data event to parent and logs for debug.
     */
    emitRefreshData() {
      this.$emit('refresh-data');
    }
  }
};
</script>

<style scoped>
</style>
